import React, { useMemo } from "react";
import { Mail } from "lucide-react";
import LogoMark from "../brand/LogoMark";
import { useI18n } from "../i18n";
import { getPageData } from "./pageData";

const Footer = () => {
  const { t } = useI18n();
  const dataSource = useMemo(() => getPageData(t).footer, [t]);

  return (
    <footer className="nfw-footer">
      <span className="nfw-anchor" id="contact" />
      <span className="nfw-anchor" id="about" />
      <div className="nfw-wrap">
        <div className="nfw-footer-grid">
          <div className="nfw-footer-brand-col">
            <div className="nfw-footer-brand">
              <span className="nfw-brand-mark nfw-brand-mark-footer">
                <LogoMark title="NewFW" />
              </span>
              <span className="nfw-brand-name nfw-brand-name-footer">
                NewFW
              </span>
            </div>
            <p className="nfw-footer-about">{t.about.lead}</p>
          </div>
          <div>
            <h4>{dataSource.productsLabel}</h4>
            {(dataSource.products || []).map((item) => (
              <a key={item.name} href={item.href}>
                {item.name}
              </a>
            ))}
            <h4 className="nfw-footer-h4-follow">{dataSource.solutionsLabel}</h4>
            {(dataSource.solutions || []).map((item) => (
              <a key={item.name} href={item.href}>
                {item.name}
              </a>
            ))}
          </div>
          <div>
            <h4>{dataSource.contactLabel}</h4>
            {dataSource.email && (
              <a className="nfw-footer-mail" href={`mailto:${dataSource.email}`}>
                <Mail size={14} style={{ marginRight: 8, verticalAlign: -2 }} />
                {dataSource.email}
              </a>
            )}
            <a href="/blog">{dataSource.blog}</a>
            <a
              href={dataSource.briefHref}
              target="_blank"
              rel="noopener noreferrer"
            >
              {dataSource.brief}
            </a>
          </div>
        </div>
        <div className="nfw-footer-bottom">
          <div>{dataSource.copyright}</div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
